export default __webpack_public_path__ + "static/media/luna.7f0d3b64.png";